export default {
	namespaced: true,
	state: {
		rejected: false,
		accepted: false
	},
	mutations: {
		enable(state) {
			state.accepted = true;
			state.rejected = false;
		},
		disable(state) {
			state.accepted = false;
			state.rejected = true;
		},
		updateFromStorage(state, payload) {
			Object.entries(payload).forEach(([key, value]) => {
				state[key] = value;
			});
		}
	},
	getters: {
		showDialog: state => !state.rejected && !state.accepted,
		trackingEnabled: state => state.accepted
	}
};
